import LiveClientsList from './List';

const LiveClientsIndex = {
  LiveClientsList, 
};

export default LiveClientsIndex;